import type { JSX } from 'react';
import { RegisteredCmsComponents } from '../../components/CmsContent/RegisteredCmsComponents';

import type { CmsData } from '../../../interfaces/webapp_json';

export type ContentExternalProps = {
  /** initial json data used to render cms content */
  data: CmsData;
};

/**
 * This component displays cms content on SIS pages
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in @apps/shopping pages or null if no data exist
 */
export const ContentExternal = ({ data }: ContentExternalProps): JSX.Element | null =>
  Array.isArray(data.paragraph) && data.paragraph?.length > 0 ? (
    <div className="m-0 p-0">
      <RegisteredCmsComponents paragraphs={data.paragraph} pageTemplate="sis" />
    </div>
  ) : null;
